import { render } from "./edit_udfarea.vue?vue&type=template&id=8cff2250"
import script from "./edit_udfarea.vue?vue&type=script&lang=js"
export * from "./edit_udfarea.vue?vue&type=script&lang=js"

import exportComponent from "E:\\devops.aliyun\\deyi\\baobei_web2\\web2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__